import game1Icon from "./Characters/1.png";
import luxurySlotIcon from "./Characters/7.png";
import jockerIcon from "./Characters/11.png";
import rouletteIcon from "./Characters/roulette_logo.png";
import aviatorIcon from "./Characters/aviator_logo.png";
import pokerIcon from "./Characters/pokerLogo.png";
import fishIcon from "./Characters/FishLogo.png";
import evilLoveSlotIcon from "./Characters/EvilLove.png";
export const gameData = [
  {
    title: "Hexa Sort",
    icon: game1Icon,
    description: "this is hexa sort game",
    playLink: "https://dhanu9721.github.io/TestHtml5/",
  },
  {
    title: "Hexa Sort",
    icon: game1Icon,
    description: "this is hexa sort game",
    playLink: "https://dhanu9721.github.io/TestHtml5/",
  },
  {
    title: "Hexa Sort",
    icon: game1Icon,
    description: "this is hexa sort game",
    playLink: "https://dhanu9721.github.io/TestHtml5/",
  },
  {
    title: "Hexa Sort",
    icon: game1Icon,
    description: "this is hexa sort game",
    playLink: "https://dhanu9721.github.io/TestHtml5/",
  },
  {
    title: "Hexa Sort",
    icon: game1Icon,
    description: "this is hexa sort game",
    playLink: "https://dhanu9721.github.io/TestHtml5/",
  },
];

export const ourGamesData = {
  All: [
    {
      id:"1",
      name: "Video Poker",
      category: "Slot",
      link: "https://dhanu9721.github.io/VideoPokerDemo/",
      icon: jockerIcon,
      orientation: "landscape",
    },
    {
      id:"2",
      name: "Luxury Slot",
      category: "Slot",
      link: "https://dhanu9721.github.io/LifeOfLuxurySlotDemo/",
      icon: luxurySlotIcon,
      orientation: "landscape",
    },
    {
      id:"3",
      name: "Roulette",
      category: "Slot",
      link: "https://dhanu9721.github.io/RouletteDemo/",
      icon: rouletteIcon,
      orientation: "landscape",
    },
    {
      id:"4",
      name: "Aviator",
      category: "Multiplayer",
      link: "https://dhanu9721.github.io/AviatorDemo/",
      icon: aviatorIcon,
      orientation: "landscape",
    },
    {
      id:"5",
      name: "Texas Poker",
      category: "Multiplayer",
      link: "https://dhanu9721.github.io/TexasPokerDemo/",
      icon: pokerIcon,
      orientation: "landscape",
    },
    {
      id:"6",
      name: "Ocean War",
      category: "Multiplayer",
      link: "https://dhanu9721.github.io/FishGameCocosDemo/",
      icon: fishIcon,
      orientation: "landscape",
    },
    {
      id:"7",
      name: "Evil Love Slot",
      category: "Slot",
      link: "https://dhanu9721.github.io/EvilLoveSlotDemo/",
      icon: evilLoveSlotIcon,
      orientation: "landscape",
    },
    {
      id:"8",
      name: "Black Jack",
      category: "Multiplayer",
      link: "https://dhanu9721.github.io/TexasPokerDemo/",
      icon: game1Icon,
      orientation: "landscape",
    },
    {
      id:"9",
      name: "Teen Patti",
      category: "Multiplayer",
      link: "https://dhanu9721.github.io/TexasPokerDemo/",
      icon: game1Icon,
      orientation: "landscape",
    },
    {
      id:"10",
      name: "Rummy",
      category: "Multiplayer",
      link: "https://dhanu9721.github.io/TexasPokerDemo/",
      icon: game1Icon,
      orientation: "landscape",
    },
  ],
};

// export default {gameData,ourGamesData};
